import { FC } from "react";

interface BrandMarkProps {
  /** Rendered size in pixels. Default: 32. */
  size?: number;
  /** Optional accessible label. If omitted, the mark is aria-hidden. */
  label?: string;
}

type Geometry = {
  stroke: number;
  disk: number;
  triangle: string;
};

function pickGeometry(size: number): Geometry {
  if (size >= 64) return { stroke: 7, disk: 11, triangle: "M 46.5 44.5 L 58 50 L 46.5 55.5 Z" };
  if (size >= 40) return { stroke: 9, disk: 12, triangle: "M 46.5 44.5 L 58 50 L 46.5 55.5 Z" };
  if (size >= 32) return { stroke: 10, disk: 12.5, triangle: "M 46 44 L 59 50 L 46 56 Z" };
  if (size >= 24) return { stroke: 11, disk: 13, triangle: "M 46 43.5 L 60 50 L 46 56.5 Z" };
  return { stroke: 13, disk: 14, triangle: "M 45 42.5 L 62 50 L 45 57.5 Z" };
}

const loopPath =
  "M 28 50 C 28 32, 42 32, 50 50 C 58 68, 72 68, 72 50 C 72 32, 58 32, 50 50 C 42 68, 28 68, 28 50 Z";

export const BrandMark: FC<BrandMarkProps> = ({ size = 32, label }) => {
  const { stroke, disk, triangle } = pickGeometry(size);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {label && <title>{label}</title>}
      <path d={loopPath} stroke="var(--st-text)" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={51} cy={50} r={disk} fill="var(--st-butter)" stroke="var(--st-on-color)" strokeWidth={4} />
      <path d={triangle} fill="var(--st-on-color)" />
    </svg>
  );
};
